import * as React from 'react';

function SvgCertificateIcon(props) {
  return (
    <svg
      data-name="Certificate Icon"
      id="certificate_icon__1"
      width={props.size || 22.397}
      height={props.size || 23.973}
      viewBox="0 0 22.397 23.973"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <style>{'.certificate_icon_svg__cls-1{fill:#fff}'}</style>
      </defs>
      <g id="certificate_icon_svg__quality" transform="translate(-16.831)">
        <g
          id="certificate_icon_svg__Group_486"
          data-name="Group 486"
          transform="translate(29.771 14.325)"
        >
          <g id="certificate_icon_svg__Group_485" data-name="Group 485">
            <path
              id="certificate_icon_svg__Path_447"
              data-name="Path 447"
              className="certificate_icon_svg__cls-1"
              d="M302.589 311.852l-2.749-5.9a10.165 10.165 0 01-6.632 4.261l2.3 4.935a.781.781 0 001.442-.063l1.18-3.24.243-.113 3.24 1.18a.782.782 0 00.976-1.06z"
              transform="translate(-293.208 -305.957)"
            />
          </g>
        </g>
        <g
          id="certificate_icon_svg__Group_488"
          data-name="Group 488"
          transform="translate(19.437)"
        >
          <g id="certificate_icon_svg__Group_487" data-name="Group 487">
            <path
              id="certificate_icon_svg__Path_448"
              data-name="Path 448"
              className="certificate_icon_svg__cls-1"
              d="M81.078 0a8.593 8.593 0 108.592 8.593A8.6 8.6 0 0081.078 0zm4.181 7.961l-1.524 1.485.36 2.1a.782.782 0 01-1.134.823l-1.884-.99-1.884.99a.782.782 0 01-1.134-.823l.36-2.1L76.9 7.961a.782.782 0 01.433-1.332l2.106-.306.942-1.908a.781.781 0 011.4 0l.942 1.908 2.106.306a.782.782 0 01.429 1.332z"
              transform="translate(-72.485)"
            />
          </g>
        </g>
        <g
          id="certificate_icon_svg__Group_490"
          data-name="Group 490"
          transform="translate(16.831 14.325)"
        >
          <g id="certificate_icon_svg__Group_489" data-name="Group 489">
            <path
              id="certificate_icon_svg__Path_449"
              data-name="Path 449"
              className="certificate_icon_svg__cls-1"
              d="M19.655 305.957l-2.749 5.9a.782.782 0 00.975 1.064l3.24-1.18.243.113 1.18 3.24a.781.781 0 001.442.063l2.3-4.935a10.164 10.164 0 01-6.631-4.265z"
              transform="translate(-16.831 -305.957)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCertificateIcon;
